































































































import { Component } from 'vue-property-decorator';
import { TestimonialsItemModel, testimmonialsItems } from '@web/models/HomeModels/TestimonialsItemModel';
import HomeSection from './Section.abstract';

@Component
export default class HomeTestimonials extends HomeSection {
  public testimmonialsItems: TestimonialsItemModel[] = testimmonialsItems;

  public currentPosition = 3;

  headersAppearence = true;

  headersRefs = {
    header: 'header',
  }
}
